import { Component, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { take } from 'rxjs/operators';
import { AgendaService } from 'src/app/pages/agenda/services/agenda.service';
import { EnumleaveTimeType } from 'src/app/pages/atestados/models/atestado';
import { EOrdenacao } from 'src/app/shared/data/ordenacao.enum';
import { ERoleAdminString } from 'src/app/shared/data/role.enum';
import { SessionService } from 'src/app/shared/services/session.service';
import { ESolicitacaoConsultaStatus, ISolicitacaoConsultaFiltros, IConsulta } from '../consultas/data/consultas';
import { IListByFilterMedico, IMedico } from '../doctors/models/doctor';
import { DoctorService } from '../doctors/services/doctor.service';

@Component({
  selector: 'app-proximas-consultas',
  templateUrl: './proximas-consultas.component.html',
  styleUrls: ['./proximas-consultas.component.scss']
})
export class ProximasConsultasComponent implements OnInit {
  ordenarControl = new UntypedFormControl(EOrdenacao.MaisAntigos);
  acaoInput = new UntypedFormControl();
  doctorControl = new UntypedFormControl('');

  opcoesOrdenacao = [
    {
      value: EOrdenacao.AlfabeticaAZ,
      label: 'Alfabética - de A a Z'
    },
    {
      value: EOrdenacao.AlfabeticaZA,
      label: 'Alfabética - de Z a A'
    },
    {
      value: EOrdenacao.MaisNovos,
      label: 'Mais distantes'
    },
    {
      value: EOrdenacao.MaisAntigos,
      label: 'Próximas'
    }
  ];

  doctors: IMedico[] = [];
  isDoctor = true;

  consultas: IConsulta[] = [];
  EnumLeaveType = EnumleaveTimeType;
  ESolicitacaoConsultaStatus = ESolicitacaoConsultaStatus;

  dadosPaginacao = {
    ordenacao: EOrdenacao.MaisAntigos,
    paginaSelecionada: 0,
    tamanhoPagina: 10,
    totalPaginas: 0,
    itensTotal: 0,
    periodStart: 0,
    periodEnd: 0
  };

  constructor(
    private readonly agendaService: AgendaService,
    private readonly doctorService: DoctorService,
    private readonly sessionService: SessionService
  ) {}

  ngOnInit(): void {
    this.isDoctor = this.sessionService.getSession().role === ERoleAdminString.Doctor;

    this.carregarConsultas();
    this.carregarMedicos();

    this.ordenarControl.valueChanges.subscribe((ordenacaoSelecionada: EOrdenacao) => {
      this.dadosPaginacao.ordenacao = ordenacaoSelecionada;
      this.carregarConsultas();
    });
  }

  filtrar(): void {
    this.carregarConsultas();
  }

  limparFiltros(): void {
    this.acaoInput.reset();
    this.carregarConsultas();
  }

  carregarConsultas(): void {
    let dateStart = new Date();
    dateStart.setHours(0, 0, 0, 0);

    const filtros: ISolicitacaoConsultaFiltros = {
      orderBy: Number(this.dadosPaginacao.ordenacao),
      pageNumber: Number(this.dadosPaginacao.paginaSelecionada),
      pageSize: Number(this.dadosPaginacao.tamanhoPagina),
      companyId: this.sessionService.getSession().companyId!,
      periodStart: dateStart.toISOString(),
      status: Number(this.ESolicitacaoConsultaStatus.consultaAceita)
    };

    const partnerId = this.sessionService.getSession().partnerId;
    const companyId = this.sessionService.getSession().companyId;
    const accountRole = this.sessionService.getSession().accountRole;

    if (partnerId) {
      filtros.partnerId = partnerId;
    }

    if (companyId) {
      filtros.companyId = companyId;
    }

    if (accountRole) {
      filtros.accountRole = parseInt(accountRole);
    }

    if (this.isDoctor) {
      filtros.doctorId = this.sessionService.getSession().sid;
    } else if (this.doctorControl.value) {
      filtros.doctorId = this.doctorControl.value;
    }

    if (this.acaoInput.value) {
      filtros.searchText = String(this.acaoInput.value);
    }

    this.agendaService.carregarConsultasPaginadas(filtros).subscribe((res) => {
      this.consultas = res.data;
      this.dadosPaginacao.totalPaginas = Math.ceil(res.count! / this.dadosPaginacao.tamanhoPagina);
      this.dadosPaginacao.itensTotal = res.count!;
    });
  }

  public mudouPagina(paginaSelecionada: number): void {
    this.dadosPaginacao.paginaSelecionada = paginaSelecionada;

    this.carregarConsultas();
  }

  public mudouTamanhoPagina(itensPaginaSelecionada: number): void {
    this.dadosPaginacao.tamanhoPagina = itensPaginaSelecionada;
    this.dadosPaginacao.paginaSelecionada = 0;

    this.carregarConsultas();
  }

  private carregarMedicos(): void {
    if (!this.isDoctor) {
      const partnerId = this.sessionService.getSession().partnerId;
      const accountRole = this.sessionService.getSession().accountRole;
      const companyId = this.sessionService.getSession().companyId;

      const filtros: IListByFilterMedico = {
        pageNumber: 0,
        pageSize: 9999,
        orderBy: EOrdenacao.AlfabeticaAZ,
        active: true
      };

      if (accountRole) {
        filtros.accountRole = parseInt(accountRole);
      }

      if (partnerId) {
        filtros.partnerId = partnerId;
      }

      if (companyId) {
        filtros.companyId = companyId;
      }

      this.doctorService
        .listarTodosMedicos(filtros)
        .pipe(take(1))
        .subscribe((res) => {
          if (res.isSucceed) {
            this.doctors = res.data;
          }
        });
    }

    this.doctorControl.valueChanges.subscribe(() => {
      this.carregarConsultas();
    });
  }
}
